import { Component, OnInit } from '@angular/core';
import { UserService, HelpKey } from '../../services/user.service';
import { User } from '../../models/user';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { HelpDialogComponent } from '../../pages/help-dialog/help-dialog.component';
import { AcknowledgeDialogComponent } from '../../pages/acknowledge-dialog/acknowledge-dialog.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  selectedUser: User | null = null;
  userPermission: string[] = [];
  subscribedProducts: string[] = ['GeoAstra NTRIP Caster - Free Edition'];

  constructor(private userService: UserService, public dialog: MatDialog) {}

  ngOnInit() {
    this.loadUser();
    this.loadPermissions();
  }

  loadUser() {
    this.userService.getUser().subscribe((data: User[]) => {    
      this.selectedUser = data[0];
    });
  }

  loadPermissions() {
    this.userService.getUserPermissions().subscribe({
      next: (perms) => {
        this.userPermission = Array.isArray(perms) ? perms : [];
        this.rebuildSubscribedProducts();
      },
      error: _ => {
        // keep only Free Edition on failure
        this.userPermission = [];
        this.subscribedProducts = ['GeoAstra NTRIP Caster - Free Edition'];
      }
    });
  }

  get profileName(): string {
    return (
      this.selectedUser?.userName ||
      this.selectedUser?.email ||
      this.selectedUser?.userId ||
      ''
    );
  }

  private rebuildSubscribedProducts(): void {
    const items: string[] = ['GeoAstra NTRIP Caster - Free Edition'];
    const has = (k: string) => this.userPermission.includes(k);
    if (has('ntrip-pro')) {
      items.push('GeoAstra NTRIP Caster - Pro Edition');
      items.push('RTK Base Analyzer (Basic Edition)');
      items.push('PPK Downloader (Basic Edition)');
    }
    if (has('ntrip-ent')) {
      items.push('GeoAstra NTRIP Caster - Enterprise Edition');
    }
    if (has('analyzer')) {
      items.push('GeoAstra RTK Base Analyzer');
    }
    if (has('downloader')) {
      items.push('GeoAstra PPK Downloader');
    }
    // de-duplicate while preserving order
    const seen = new Set<string>();
    this.subscribedProducts = items.filter(p => (seen.has(p) ? false : (seen.add(p), true)));
  }

  onSubmit(): void {
    if (this.selectedUser) {
      this.userService.updateCurrentUser(this.selectedUser).subscribe({
        next: (response) => {
          console.log('User Updated successfully:', response); 
          this.loadUser(); 
          this.dialog.open(AcknowledgeDialogComponent, {
            data: 'User update successful.'
          });
          this.userService.ntripApplyWithLogging();
        },
        error: (error) => {
          console.error('Failed creating new user:', error);
          this.loadUser();  
          this.dialog.open(AcknowledgeDialogComponent, {
            data: 'New user creation failed！'
          });
        }
      });
    } else {
      console.error('no user selected');
    }
  }
  
  showHelp(key: HelpKey): void {
    const dialogRef = this.dialog.open(HelpDialogComponent, {
      width: '250px',
      data: this.userService.helpData[key]
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('帮助对话框已关闭');
    });
  }

  onDeleteAllNtripData(): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { title: 'Delete all your NTRIP data?', message: 'This will permanently delete all your data previously downloaded from your base station(s). Proceed?' }
    });
    ref.afterClosed().subscribe((ok: boolean) => {
      if (!ok) return;
      this.userService.deleteMyNtripData().subscribe({
        next: (out) => {
          const a = out?.analyzer?.deleted ?? 0;
          const d = out?.downloader?.deleted ?? 0;
          this.dialog.open(AcknowledgeDialogComponent, { data: `Deleted. Analyzer: ${a}, Downloader: ${d}.` });
        },
        error: (err) => {
          const msg = err?.error?.error || err?.message || 'Delete failed';
          this.dialog.open(AcknowledgeDialogComponent, { data: msg });
        }
      });
    });
  }
}